import {
  Document,
  PDFViewer,
  Page as PDFPage,
  StyleSheet,
  Text as PDFText,
  View as PDFView,
  Image as PDFImage,
  Font
} from '@react-pdf/renderer';
Font.register({
  family: 'Roboto',
  fonts: [{ src: '/Roboto-Bold.ttf', fontWeight: 'bold' }]
});

const styles = StyleSheet.create({
  page: {
    padding: 20
  },
  heading: {
    fontSize: 18,
    textAlign: 'center',
    marginBottom: 20
  },
  line: {
    height: 0.6,
    backgroundColor: 'black',
    marginVertical: 10,
    marginTop: '40px'
  },
  line2: {
    height: 0.4,
    backgroundColor: 'black',
    marginVertical: 10
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 0,
    marginBottom: 0,
    border: '1px Solid black',
    padding: '10px'
  },
  contentContainer2: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 0,
    marginBottom: 0
  },
  column: {
    flex: 1,
    paddingHorizontal: 10
  },
  row: {
    flexDirection: 'row',
    marginBottom: 0
  },
  text: {
    fontSize: 7,
    display: 'inline-block'
  },
  textBold: {
    fontSize: 9,
    fontWeight: 'bold'
  },
  textUnderlined: {
    textDecoration: 'underline'
  },

  columnHeader: {
    width: '15%',
    backgroundColor: '#1976D2',
    color: 'white',
    padding: 5,
    textAlign: 'center'
  },
  columnContent: {
    width: '15%',
    padding: 6,
    textAlign: 'center',
    alignItems: 'center'
  }
});

const fullScreenStyles = {
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    zIndex: 1000,
    backgroundColor: 'white'
  }
};

const COLORS = ['#f0f0f0', '#e0e0e0'];

const Page = ({ style, children, ...props }) => (
  <PDFPage style={{ ...styles.page, ...style }} {...props}>
    {children}
  </PDFPage>
);

const View = ({ style, children, ...props }) => (
  <PDFView style={{ ...style }} {...props}>
    {children}
  </PDFView>
);

const Text = ({ style, content, ...props }) => (
  <PDFText style={{ ...styles.text, ...style }} {...props}>
    {content}
  </PDFText>
);

export const RefundRegisterReportPdf = ({ data }) => {
  console.log(data);
  const user = JSON.parse(localStorage.getItem('user'));
  let totalRecdCash = 0;

  // Function to format the date as needed (e.g., dd/mm/yyyy)
  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  return (
    <div style={fullScreenStyles.container}>
      <PDFViewer width="100%" height="100%" showToolbar>
        <Document title="Refund Register Report">
          <Page style={styles.page} size="A4" orientation="landscape">
            <PDFImage
              src="/logo_Hospital_m.jpeg"
              style={{ width: '100%', height: '80px', marginBottom: 1, marginRight: '10%' }}
            />
            <View style={styles.row}>
              <Text style={styles.columnHeader} content="Sr No." />
              <Text style={styles.columnHeader} content="Refund Date" />
              <Text style={styles.columnHeader} content="Refund No." />
              <Text style={{ ...styles.columnHeader, width: '200px' }} content="Patient Name" />
              <Text style={styles.columnHeader} content="UHID No." />
              <Text style={{ ...styles.columnHeader }} content="Adm No." />
              <Text style={{ ...styles.columnHeader, width: '200px' }} content="Doctor Name" />
              <Text style={styles.columnHeader} content="Refund Type" />
              <Text style={styles.columnHeader} content="Total Refund" />
              <Text style={styles.columnHeader} content="CreatedBy" />
            </View>

            {data &&
              data.map((item, index) => {
                totalRecdCash += item.amount;

                return (
                  <View key={index} style={{ ...styles.row, backgroundColor: COLORS[index % COLORS.length] }}>
                    <Text style={styles.columnContent} content={index + 1} />
                    <Text style={styles.columnContent} content={formatDate(item.date)} />
                    <Text style={styles.columnContent} content={item.doc_no} />
                    <Text style={{ ...styles.columnContent, width: '200px' }} content={`${item.patientName}`} />
                    <Text style={styles.columnContent} content={item.uhid} />
                    <Text style={styles.columnContent} content={item.ipd_no} />
                    <Text style={{ ...styles.columnContent, width: '200px' }} content={item.consultant.doctor} />
                    <Text style={styles.columnContent} content={item.payment_mode} />
                    <Text style={styles.columnContent} content={item.amount} />
                    <Text style={styles.columnContent} content={item.createdBy} />
                  </View>
                );
              })}
            <View style={{ ...styles.row, marginTop: 20, width: '100%', marginLeft: '83%' }}>
              <Text
                style={{ ...styles.columnContent, width: '5%', fontSize: '8px', fontFamily: 'Roboto' }}
                content="Total"
              />
              <Text
                style={{ ...styles.columnContent, fontSize: '8px', fontFamily: 'Roboto' }}
                content={totalRecdCash}
              />
            </View>
          </Page>
        </Document>
      </PDFViewer>
    </div>
  );
};

export default RefundRegisterReportPdf;
